import { VideoPlayer } from "@jmc/solid-design-system/src/components/organisms/VideoPlayer/VideoPlayer";
import React, { ReactElement } from "react";
import style from "./style.module.scss";
import { FlexibleGrid } from "@jmc/solid-design-system/src/components/atoms/FlexibleGrid/FlexibleGrid";

interface PropTypes {
    children: ReactElement<VideoPlayer> | ReactElement<VideoPlayer>[];
}

export const VideoPlayerGallery = ({ children }: PropTypes) => {
    return (
        <div className={style.element} data-test-id="VideoPlayerGallery">
            <FlexibleGrid
                maxTwoColumnSm
                fractions={React.Children.count(children) > 4 ? [1, 1, 1, 1] : React.Children.map(children, () => 1)}
            >
                {React.Children.map(children, (child, index: number) => {
                    return (
                        <div key={index} className={style.child} data-test-id="VideoPlayerGallery.Video">
                            {child}
                        </div>
                    );
                })}
            </FlexibleGrid>
        </div>
    );
};
